import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import Spacer from '../../components/spacer'
import ImageScale from '../../components/scale/image_scale'
import css from './style.css'

const CaratSection = props => {
  /** ------------ */
  /** CARAT SCALE  */
  /** ------------ */
  const caratImg1 = require('./images/caratScale/0.25ct.png')
  const caratImg2 = require('./images/caratScale/0.50ct.png')
  const caratImg3 = require('./images/caratScale/0.75ct.png')
  const caratImg4 = require('./images/caratScale/1.00ct.png')
  const caratImg5 = require('./images/caratScale/1.50ct.png')
  const caratImg6 = require('./images/caratScale/2.00ct.png')
  const caratImg7 = require('./images/caratScale/2.50ct.png')
  const caratImg8 = require('./images/caratScale/3.00ct.png')
  const caratImg9 = require('./images/caratScale/4.00ct.png')
  const caratImg10 = require('./images/caratScale/5.00ct.png')

  const caratScale = [
    {
      elements: [
        { img: caratImg1, name: '0.25 ct', imgStyle: {'height': '15px'} },
        { img: caratImg2, name: '0.50 ct', imgStyle: {'height': '20px'} },
        { img: caratImg3, name: '0.75 ct', imgStyle: {'height': '22px'} },
        { img: caratImg4, name: '1.00 ct', imgStyle: {'height': '25px'} },
        { img: caratImg5, name: '1.50 ct', imgStyle: {'height': '28px'} },
        { img: caratImg6, name: '2.00 ct', imgStyle: {'height': '31px'} },
        { img: caratImg7, name: '2.50 ct', imgStyle: {'height': '33px'} },
        { img: caratImg8, name: '3.00 ct', imgStyle: {'height': '35px'} },
        { img: caratImg9, name: '4.00 ct', imgStyle: {'height': '39px'} },
        { img: caratImg10, name: '5.00 ct', imgStyle: {'height': '42px'} }
      ]
    }
  ]
  return (
    <div>
      <Grid>
        <div className={css.pinkBg2} />
        <GridItem col='3/5' customStyle={css.gridItem}>
          <img className={css.image}
            src={require('./images/carat_diamond_ring.png')}
            srcSet={[
              require('./images/carat_diamond_ring.png') + ' 1x',
              require('./images/carat_diamond_ring@2x.png') + ' 2x'
            ].join(', ')}
          />
        </GridItem>
        <GridItem col='1/10' customStyle={css.gridItem} />
        <GridItem col='3/10' customStyle={css.gridItem}>
          <div className={css.title}>
            Carat
          </div>
          <p className={css.text}>
            Carat is the term used for the weight of a diamond. The size of a diamond is up to both your budget and personal preference. At Kimberfire, we aim to maximize the size of the diamond you can purchase within your budget, without going below our quality standards on the other three of the four C’s.
          </p>
        </GridItem>
      </Grid>
      <Spacer xl />
      <Grid>
        <GridItem col='1/1' customStyle={css.gridItem}>
          <ImageScale elements={caratScale} imgHeight={64} />
        </GridItem>
      </Grid>
    </div>
  )
}

export default CaratSection



// WEBPACK FOOTER //
// ./src/containers/diamond/carat_section.js